// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Provides helper methods for generating random identifiers and GUIDs.
 */
export class Random
{
  private static incrementNumber: number = 0;

  static generateRequestID(): string
  {
    return this.generateRandomHexID("r", 12);
  }

  static generateSocketID(): string
  {
    return this.generateRandomHexID("s", 12);
  }

  static generateConnectionID(): string
  {
    return this.generateRandomHexID("c", 12);
  }

  static generateGuid(): string
  {
    function generateSpecialHexChar(): string
    {
      let value = Math.random() * 16 | 0;
      value = value & 0x3 | 0x8;
      return value.toString(16);
    }

    function generateHexChars(amount: number): string
    {
      let result = "";
      for (let i = 0; i < amount; i++)
        result = result + (Math.random() * 16 | 0).toString(16);

      return result;
    }

    return `${generateHexChars(8)}-${generateHexChars(4)}-4${generateHexChars(3)}-${generateSpecialHexChar()}${generateHexChars(3)}-${generateHexChars(12)}`;
  }

  private static generateRandomHexID(value: string, amount: number): string
  {
    for (let i = 0; i < 12; i++)
      value = value + (Math.random() * 16 | 0).toString(16);

    return `${value}.${this.incrementNumber++}`;
  }
}